document.addEventListener('DOMContentLoaded', function () {
    var downloadLinks = document.querySelectorAll('a.download, a.download-pdf, a.visual-block-download');
    
    downloadLinks.forEach(function(downloadLink) {
        downloadLink.addEventListener('click', function(event) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', this.href, true);
            xhr.responseType = 'blob';
            xhr.onload = function() {
                var a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhr.response);
                
                var parsedUrl = new URL(this.responseURL);
                var pathname = parsedUrl.pathname;
                var filename = pathname.substring(pathname.lastIndexOf('/') + 1);
                var pdfName = filename.split('?')[0];
                
                a.download = pdfName; 
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            };
            xhr.send();
            event.preventDefault();
        });
    });

    // JavaScript pour ajouter les data-label dynamiquement
    const tables = document.querySelectorAll("table");
  
    tables.forEach((table) => {
      const headers = Array.from(table.querySelectorAll("thead th"));
  
      table.querySelectorAll("tbody tr").forEach((row) => {
        Array.from(row.children).forEach((cell, index) => {
          if (headers[index]) {
            cell.setAttribute("data-label", headers[index].innerText);
          }
        });
      });
    });

    // calcul du positionnement des onglets de l'espace client en mobile
    if (window.innerWidth < 1025) {
        var bloc = document.getElementById('block-gorgytime-views-block-espace-client-onglets-block-1');
        var rows = bloc.querySelectorAll('.views-row');
        var somme = 0;
        var i=0;
        rows.forEach(function(row) {
            if (i==0){
                somme += window.innerWidth;
            }else{
                somme += row.getBoundingClientRect().width + 16;
            }
            i++;
        });
        document.querySelector('#block-gorgytime-views-block-espace-client-onglets-block-1 > div').style.width = somme + "px";
        document.querySelector("#block-gorgytime-views-block-espace-client-onglets-block-1").scrollLeft = document.querySelector(".boite.actif").offsetLeft - 35;
    }

});
